
import Vue from "vue";
import {post} from '../service/http-service';
import API from '../service/config';
declare var $: any;

export default Vue.extend({
  name: "ToolsLeft",
  props: {
    animate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sequenceValue: '',
      beNotifiedByEmail: false,
      dataType1: ['scATAC'],
      dataType2: ['GWAS'],
      datasetId1: null,
      datasetId2: null,
      datasetIdArr1: null,
      datasetIdArr2: null,
      keyName: 'job_id',
      jobData: null,
      email: '',
      title: 'From scMoresDB Message',
      toolsetData: {
        status: 1,
        datasetId: "",
        datasetData: null,
        to: '',
        title: 'From scMoresDB Message',
      },
      subimitData: null,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData(){
       post(API.domainUrl + API.getDataset, this.dataType1).then((response:any)=>{
        if(response.status.code == 200){
          this.datasetIdArr1 = response.data || [];
          this.datasetId1 = response.data[0];
         
        }
      }),
      post(API.domainUrl + API.getDataset, this.dataType2).then((response:any)=>{
        if(response.status.code == 200){
          this.datasetIdArr2 = response.data || [];
            this.datasetId2 = response.data[0];
        }
      })
    },
    runJob(){
      let reqNodes:any = [];
        reqNodes.push({
            dataType: 'scATAC',
            datasetId: this.datasetId1,
        });
        reqNodes.push({
            dataType: 'GWAS',
            datasetId: this.datasetId2,
        });
        this.toolsetData.datasetId = JSON.stringify(reqNodes);
        this.toolsetData.to = this.email;
        this.toolsetData.title = this.title;
      post(API.domainUrl + API.runJob,this.toolsetData).then((response:any)=>{
        if(response.status.code == 200){
            this.jobData = response.data;
            let id:string = '';
            console.log("localStorage",localStorage.getItem(this.keyName));
            // if(this.$cookies.isKey(this.keyName)){
            //     id =this.$cookies.get(this.keyName)+','+response.data.jobId;
            // }else{
            //     id=response.data.jobId;
            // }
            if(localStorage.getItem(this.keyName)){
                id =localStorage.getItem(this.keyName)+','+response.data.jobId;
            }else{
                id=response.data.jobId;
            }
            localStorage.setItem(this.keyName,id)
            //this.$cookies.set(this.keyName,id);
            console.log("localStorage",localStorage.getItem(this.keyName));
            this.$emit('transfer');
            if(this.email && response.data.emailS == 1){
            this.$message.success((this.$t('emailSuccess')) as string)
            }else{
              this.$message.success((this.$t('jobSuccess')) as string);
            }
        }else{
          this.$message.error((this.$t('jobError')) as string);
        }
      })

    },
    inputExample(){
      this.sequenceValue = `>[known_CEBP_binding_increase]GtoT__chr1_109817091_109818090
                      GTGCCTCTGGGAGGAGAGGGACTCCTGGGGGGCCTGCCCCTCATACGCCATCACCAAAAG
                      GAAAGGACAAAGCCACACGCAGCCAGGGCTTCACACCCTTCAGGCTGCACCCGGGCAGGC
                      CTCAGAACGGTGAGGGGCCAGGGCAAAGGGTGTGCCTCGTCCTGCCCGCACTGCCTCTCC
                      CAGGAACTGGAAAAGCCCTGTCCGGTGAGGGGGCAGAAGGACTCAGCGCCCCTGGACCCC
                      CAAATGCTGCATGAACACATTTTCAGGGGAGCCTGTGCCCCCAGGCGGGGGTCGGGCAGC
                      CCCAGCCCCTCTCCTTTTCCTGGACTCTGGCCGTGCGCGGCAGCCCAGGTGTTTGCTCAG
                      TTGCTGACCCAAAAGTGCTTCATTTTTCGTGCCCGCCCCGCGCCCCGGGCAGGCCAGTCA
                      TGTGTTAAGTTGCGCTTCTTTGCTGTGATGTGGGTGGGGGAGGAAGAGTAAACACAGTGC
                      TGGCTCGGCTGCCCTGAGGTTGCTCAATCAAGCACAGGTTTCAAGTCTGGGTTCTGGTGT
                      CCACTCACCCACCCCACCCCCCAAAATCAGACAAATGCTACTTTGTCTAACCTGCTGTGG
                      CCTCTGAGACATGTTCTATTTTTAACCCCTTCTTGGAATTGGCTCTCTTCTTCAAAGGAC
                      CAGGTCCTGTTCCTCTTTCTCCCCGACTCCACCCCAGCTCCCTGTGAAGAGAGAGTTAAT
                      ATATTTGTTTTATTTATTTGCTTTTTGTGTTGGGATGGGTTCGTGTCCAGTCCCGGGGGT
                      CTGATATGGCCATCACAGGCTGGGTGTTCCCAGCAGCCCTGGCTTGGGGGCTTGACGCCC
                      TTCCCCTTGCCCCAGGCCATCATCTCCCCACCTCTCCTCCCCTCTCCTCAGTTTTGCCGA
                    `
    },
    clearExample(){
      this.sequenceValue = '';
    },
    uploadFile(event:any,name:string) {
      event.preventDefault();

      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('file', file);
      post('',formData).then((response:any)=>{        
        if(response.status.code == 200){
          if(name == 'uploadFile'){

          }else{

          }
        }else{
          this.$message.error(response.status.msg);
        }
      })
      $('#' + name).val('');
    }
  }
});
